const carouselItems = [
  {
    title: '国产剧年度盛典',
    subtitle: '2024口碑佳作全回顾',
    desc: '从《繁花》到《庆余年第二季》，国产电视剧迎来质量与热度双丰收的一年。本专题带你回顾全年必看剧目，深度解析创作幕后。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20epic%20scene%20with%20grand%20palace%20and%20thousands%20of%20soldiers%2C%20dramatic%20golden%20sunset%20lighting%2C%20cinematic%20scale%2C%20film%20poster%20quality&width=1200&height=700&seq=bbtv-carousel-01&orientation=landscape',
  },
  {
    title: '科幻电影进化论',
    subtitle: '从《流浪地球》到国产科幻崛起',
    desc: '国产科幻电影用实力证明了自己。从特效技术到叙事深度，《流浪地球》系列如何引领中国科幻走向世界舞台。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20holographic%20displays%20and%20%20astronauts%2C%20cool%20blue%20and%20white%20lighting%2C%20sci-fi%20movie%20quality%2C%20epic%20scale&width=1200&height=700&seq=bbtv-carousel-02&orientation=landscape',
  },
  {
    title: '悬疑推理剧热潮',
    subtitle: '烧脑神作背后的故事',
    desc: '为什么观众越来越爱看悬疑剧？从剧本创作到导演手法，深度揭秘高分悬疑剧集的制作密码与观众心理。',
    img: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20scene%20with%20detective%20desk%20covered%20in%20photos%20and%20evidence%2C%20moody%20venetian%20blind%20shadows%2C%20film%20noir%20aesthetic%2C%20suspenseful%20atmosphere&width=1200&height=700&seq=bbtv-carousel-03&orientation=landscape',
  },
  {
    title: '韩剧全球化密码',
    subtitle: '从《鱿鱼游戏》到文化输出',
    desc: '韩剧如何从亚洲走向全球？分析韩剧的制作模式、叙事特点和全球传播策略，看韩国如何用内容征服世界观众。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20emotional%20moment%20in%20rain%20with%20colorful%20umbrellas%2C%20romantic%20cinematic%20lighting%2C%20soft%20bokeh%2C%20k-drama%20iconic%20style&width=1200&height=700&seq=bbtv-carousel-04&orientation=landscape',
  },
  {
    title: '动漫新纪元',
    subtitle: '国漫崛起与日漫进化',
    desc: '中国动画产业迎来黄金时代，从《哪吒》到《深海》，技术与艺术的双重突破。同时日漫经典IP也在不断进化创新。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20colorful%20dynamic%20composition%2C%20studio%20ghibli%20inspired%20aesthetic%2C%20breathtaking%20landscape&width=1200&height=700&seq=bbtv-carousel-05&orientation=landscape',
  },
  {
    title: '经典港片修复计划',
    subtitle: '用4K画质重温黄金年代',
    desc: '那些陪伴我们成长的港片经典，正在通过AI修复技术重获新生。《无间道》《英雄本色》等经典4K修复版陆续上线。',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20night%20cityscape%20with%20neon%20signs%20and%20busy%20streets%2C%20cinematic%20noir%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20classic%20HK%20film%20atmosphere&width=1200&height=700&seq=bbtv-carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            深度专题 · 发现更多精彩
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心策划的深度专题内容，带你走进影视背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                  <span className="text-xs font-medium text-white/90">{item.subtitle}</span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/50">
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap cursor-pointer">
                    阅读专题 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}